export default class Rand {
    constructor() {        
    }

    /**
     * Returns a random integer in the range of 0 to limit (exclusive).
     * @param limit The max value of the resulting integer (exclusive).
     * @returns {number}
     */
    static randomInt(limit) {
        return (Math.random() * limit) | 0;
    }

}